import * as C from '../constants';
import { uniq, shuffle, difference } from 'lodash';

import config from '../config.json';

const levels = config.levels;

const initialState = {
  route: C.ROUTE_START,
  life: C.DEFAULT_LIFE,
  level: 0,
  totalLevels: 0,
  currentWord: [],
  keyboard: [],
  hint: '',
  answer: ''
}

const getUniqChars = (word) => {
  const uniqChars = uniq(word);
  return uniqChars;
}
const generateKeyboard = (word, length) => {
  const charArray = getUniqChars(word);
  const restChars = shuffle(difference(C.ALL_CHARS, charArray));
  const additionalChars = restChars.slice(0, (length - charArray.length));
  const keyboard = shuffle([...charArray, ...additionalChars]);
  const kbobj = {};
  for (let i=0; i<keyboard.length; i++){
    kbobj[keyboard[i]] = 0;
  }
  return kbobj;
}
const getWord = (level) => {
  const words = levels[level].words;
  return shuffle(words);
}
const getHint = (wordObj) => {
  if(!wordObj || !wordObj[0] || !wordObj[0].hint) return '';

  return wordObj[0].hint;
}
const getAnswer = (word, level) => {
  const words = levels[level].words;
  const wordObj = words.find((w) => {
    return w.abbr === word
  });
  if(!wordObj || !wordObj.hint) return '';
  return wordObj.answer;
}
const isLastLevel = level => level >= levels.length;
const isWordSolved = (keyboard, currentWord) => {
  const solveCount = currentWord.map(el => keyboard[el]).reduce((acc, val) => acc + val)
  return solveCount >= currentWord.length;
}
const isWordIncludeChar = (word, kbIndex) => {
  return word.includes(kbIndex);
}
const setButtonStatus = (keyboard, index, status) => {
  const kb = {...keyboard};
  kb[index] = status;
  return kb;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case C.START_GAME:
      return {
        ...state,
        route: C.ROUTE_GAME,
      }
    case C.START_LEVEL:
      let life = state.life;
      let totalLevels = state.totalLevels;
      const currentLevel = action.payload.level;
      const word = getWord(currentLevel);
      const hint = getHint(word);
      const dividedWord = word[0].abbr.toUpperCase().split("");
      const kbLength = levels[action.payload.level].kbLength;
      if (action.payload.level === 0) {
        life = C.DEFAULT_LIFE;
        totalLevels = config.levels.length;
      }
      life = action.payload.level === 0 ? C.DEFAULT_LIFE : state.life;
      return {
        ...state,
        level: action.payload.level,
        route: C.ROUTE_GAME,
        life,
        totalLevels,
        hint,
        answer: '',
        currentWord: dividedWord,
        keyboard: generateKeyboard(dividedWord, kbLength)
      }
    case C.CHECK_CHAR:
      if (isWordIncludeChar(state.currentWord, action.payload.index)) {
        const keyboard = setButtonStatus(state.keyboard, action.payload.index, 1);
        const solved = isWordSolved(keyboard, state.currentWord);
        //Буква угадана, аббревиатура разгадана
        if (solved) {
          const level = state.level + 1;
          const word = state.currentWord.join("");
          const answer = getAnswer(word, state.level);
          return {
            ...state,
            level,
            answer,
            route: isLastLevel(level) ? C.ROUTE_LAST_ANSWER : C.ROUTE_ANSWER,
          }
        }
        //Буква угадана, аббревиатура не разгадана
        return {
          ...state,
          keyboard: keyboard,
        }
      } else {
        const life = state.life - 1;
        //Буква не угадана, ходов не осталось
        if (life <= 0) {
          return {
            ...state,
            life,
            route: C.ROUTE_END,
          }
        }
        //Буква не угадана, ходы остались
        return {
          ...state,
          life,
          keyboard: setButtonStatus(state.keyboard, action.payload.index, -1)
        }
      }
    case C.FINAL_ANSWER:
      return {
        ...state,
        route: C.ROUTE_WIN,
      }
    case C.RESET_GAME:
      return initialState
    default:
      return state
  }
}